// src/App.js
import { Routes, Route, Navigate } from 'react-router-dom';
// Importe seus componentes
import DashboardLayout from './layouts/DashboardLayout';
import ProtectedRoute from './components/ProtectedRoute';
import LoginPage from './pages/LoginPage';
import ProfilePage from './pages/ProfilePage';
import DashboardPage from './pages/DashboardPage';
import OrganizationPage from './pages/OrganizationPage';
import CollaboratorsPage from './pages/CollaboratorsPage';
import OrganizationSetupPage from './pages/OrganizationSetupPage'; // Página de Setup
import OrganizationManagementPage from './pages/OrganizationManagementPage'; // Página de Gerenciamento
import CompaniesPage from './pages/CompaniesPage';
import SuperadminUsersPage from './pages/SuperadminUsersPage';
import UnauthorizedPage from './pages/UnauthorizedPage';
import SettingsPage from './pages/SettingsPage';
import PlanosFaturamento from './pages/PlanosFaturamento';
import LogoutPage from './pages/LogoutPage';
import AccountDeactivatedPage from './pages/AccountDeactivatedPage'; // <-- IMPORTAÇÃO DA NOVA PÁGINA

function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/unauthorized" element={<UnauthorizedPage />} />
      {/* ROTA PARA A PÁGINA DE CONTA DESATIVADA */}
      <Route path="/conta-desativada" element={<AccountDeactivatedPage />} />

      <Route element={<ProtectedRoute />}>
        {/* Rota de setup da organização: acessível para admin sem companyId. */}
        <Route path="/organizacao/setup" element={<OrganizationSetupPage />} />
        
        {/* Todas as outras rotas protegidas ficam dentro do DashboardLayout */}
        <Route path="/" element={<DashboardLayout />}>
          <Route index element={<Navigate to="/inicial" replace />} />
          <Route path="planos" element={<PlanosFaturamento />} />   
          <Route path="inicial" element={<DashboardPage />} />
          <Route path="organizacao/gerenciar" element={<OrganizationManagementPage />} />
          <Route path="organizacao" element={<OrganizationPage />} />
          <Route path="colaboradores" element={<CollaboratorsPage />} />
          <Route path="perfil" element={<ProfilePage />} />
          <Route path="configuracoes" element={<SettingsPage />} />
          <Route path="/logout" element={<LogoutPage />} />
          
          {/* Rotas específicas para Superadmin */}
          <Route element={<ProtectedRoute allowedRoles={['superadmin']} />}>
              <Route path="empresas" element={<CompaniesPage />} />
              <Route path="superadmin/usuarios" element={<SuperadminUsersPage />} />
          </Route>
        </Route>
      </Route>
    </Routes>
  );
}

export default App;
